// Función simple que devuelve el RE según el IVA
// NO necesita base de datos, usa valores hardcoded

export function obtenerRecargoEquivalencia(iva_pct) {
  const iva = Number(iva_pct)
  
  if (iva === 10) return 1.4
  if (iva === 4) return 0.5
  if (iva === 21) return 5.2
  
  return 0
}

// Alias para compatibilidad
export function obtenerRecargoEquivalenciaSync(iva_pct) {
  return obtenerRecargoEquivalencia(iva_pct)
}

// Función dummy para compatibilidad (no hace nada)
export async function cargarTiposIva(supabase) {
  // No hace nada - los valores están hardcoded arriba
  return true
}